import { ReactNode, useLayoutEffect } from "react";

import { useLayoutStore } from "@type/store/LayoutStore";

import { RouteType } from "types";

interface LayoutRouteProps {
  route: RouteType;
  children: ReactNode;
}

const LayoutRoute = ({ route, children }: LayoutRouteProps) => {
  const onShowBaseLayout = useLayoutStore((state) => state.onShowBaseLayout);

  useLayoutEffect(() => {
    onShowBaseLayout(!route.withoutLayout);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [route.withoutLayout]);

  return <>{children}</>;
};

export default LayoutRoute;
